import { SvgIcon } from "@mui/material"

export const CheckMark = (props) => {
  return (
    <SvgIcon fill={"none"} width="22" height="16" viewBox="0 0 22 16" {...props}>
      <path
        d="M6.60676 12.9686L2.15348 8.51531C1.65726 8.01908 0.86839 8.01908 0.372167 8.51531C-0.124056 9.01153 -0.124056 9.8004 0.372167 10.2966L5.70338 15.6278C6.1996 16.1241 7.00119 16.1241 7.49742 15.6278L20.9845 2.15348C21.4807 1.65726 21.4807 0.86839 20.9845 0.372167C20.4883 -0.124056 19.6994 -0.124056 19.2032 0.372167L6.60676 12.9686Z"
        fill="#1BC8CC"
      />
    </SvgIcon>
  )
}
